import * as React from 'react';
import { isUndefined } from 'lodash';

import { ClientFeature } from '@frontend/app/constants';
import { useClientFeatureEnabled } from './useClientFeatureEnabled';

const { useMemo } = React;

export interface InstagramDiscoveryEnabledValue {
  isInstagramDiscoveryEnabled: boolean;
  isLoading: boolean;
}

/**
 * Hook to check if Instagram Discovery features are enabled.
 * Checks both INSTAGRAM_DISCOVERY (deprecated) and INSTAGRAM_CREATOR_MARKETPLACE_DISCOVERY.
 */
export const useInstagramDiscoveryEnabled = (): InstagramDiscoveryEnabledValue => {
  // @deprecated INSTAGRAM_DISCOVERY is being superseded by INSTAGRAM_CREATOR_MARKETPLACE_DISCOVERY
  const isLegacyEnabled = useClientFeatureEnabled(ClientFeature.INSTAGRAM_DISCOVERY);
  const isNewEnabled = useClientFeatureEnabled(ClientFeature.INSTAGRAM_CREATOR_MARKETPLACE_DISCOVERY);

  return useMemo(() => {
    const isEnabled = Boolean(isLegacyEnabled || isNewEnabled);
    const isLoading = isUndefined(isLegacyEnabled) || isUndefined(isNewEnabled);

    return {
      isInstagramDiscoveryEnabled: isEnabled,
      isLoading,
    };
  }, [isLegacyEnabled, isNewEnabled]);
};
